import React, { Component } from 'react';
import Button from './Button';
import RefreshIcon from '@mui/icons-material/Refresh';
class DialogHeader extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div className={`chartHeaderBar ${this.props.classicClass}`}>
                <div className={`chartbgColor ${this.props.classicClass}`}>
                    <span className="whiteFontColor">{this.props.text}</span>
                    <div className="bg-svg">
                        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
                            <rect className="sideZero" width="40" height="40"/>
                            <path className="sideOne" d="M0,0v40h1.45L26.44,6.73C29.55,2.65,34.87,0,40,0H0z"/>
                        </svg>
                    </div>
                </div>
                <div className="d-flex">
                    {this.props.isReport && 
                        <Button
                            type="IconButton"
                            className="glyphicon glyphicon-open dashboardMenuColor"
                            name="IconButton"
                            icon={<RefreshIcon />}
                            primary={true}
                            onTouchTap={this.props.refreshAction}
                        />
                    }
                    {!this.props.nolink && <a href={this.props.link} className="d-flx-content-end">
                        <p className="detailsParagraphDash">View Full Report</p>
                    </a>}
                </div>
            </div>
        );
    }
}

export default DialogHeader;